// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'
import { UpdatedLabeledInputWrapper } from 'components/Form/updated/UpdatedLabeledInput/styles'

export const UpdatedInputWithUnitToggleWrapper = styled(UpdatedLabeledInputWrapper)`
  grid-template-columns: 1fr auto auto;
  grid-template-rows: auto 2em 1fr;
  grid-template-areas:
    "label label label"
    "input unit-toggle lookup"
    "error error error";
  
  > .unit-toggle {
    grid-area: unit-toggle;
  }
`
